import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { SelectionModifier } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface CarrierSelectionOverridesModel {
  carrierSelectionOverridesMap: Record<string, SelectionModifier>;
  setCarrierSelectionOverrides: Action<CarrierSelectionOverridesModel, SelectionModifier[]>;
  setCarrierSelectionOverride: Action<CarrierSelectionOverridesModel, SelectionModifier>;
  fetchCarrierSelectionOverridesLoading: boolean;
  setFetchCarrierSelectionOverridesLoading: Action<CarrierSelectionOverridesModel, boolean>;
  fetchCarrierSelectionOverrides: Thunk<CarrierSelectionOverridesModel, void, Injections, StoreModel, Promise<void>>;
  fetchCarrierSelectionOverridesFailure: Action<CarrierSelectionOverridesModel, ApplicationErrorOptions>;
}

export const carrierSelectionOverridesModel: CarrierSelectionOverridesModel = {
  carrierSelectionOverridesMap: {},
  setCarrierSelectionOverrides: action((state, carrierSelectionModifiers) => {
    const carrierSelectionOverridesMap = carrierSelectionModifiers.reduce<Record<string, SelectionModifier>>(
      (acc, curr) => {
        acc[curr.selectionModifierId] = curr;
        return acc;
      },
      {},
    );
    state.carrierSelectionOverridesMap = carrierSelectionOverridesMap;
  }),
  setCarrierSelectionOverride: action((state, carrierSelectionModifier) => {
    state.carrierSelectionOverridesMap[carrierSelectionModifier.selectionModifierId] = carrierSelectionModifier;
  }),
  fetchCarrierSelectionOverridesLoading: false,
  setFetchCarrierSelectionOverridesLoading: action((state, isLoading) => {
    state.fetchCarrierSelectionOverridesLoading = isLoading;
  }),
  fetchCarrierSelectionOverrides: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchCarrierSelectionOverridesLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchSelectionModifiers();
      actions.setCarrierSelectionOverrides(response);
      actions.setFetchCarrierSelectionOverridesLoading(false);
      return response;
    } catch (error) {
      actions.fetchCarrierSelectionOverridesFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchCarrierSelectionOverridesLoading(false);
      return error;
    }
  }),
  fetchCarrierSelectionOverridesFailure: action((state, error) => {
    console.error(error);
  }),
};

export default carrierSelectionOverridesModel;
